<template>
  <div>
       <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-3">
                <div class="title primary--text">
                    <h4>{{$t('enrollment.steps.ask_detail.component.title')}}</h4>
                </div>
            </v-flex>
            <AskNameAndPhone
            ref="namephoneform"
            :name.sync="name"
            :phone.sync="phone"
            :country_code="country_code"
            >
            </AskNameAndPhone>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click.stop="onConfirm"
            >{{ $t("enrollment.steps.continue.button") }}</v-btn
            >
        </v-card-actions>
  </div>
</template>

<script>
import AskNameAndPhone from "@/components/consumer/AskNameAndPhone"

export default {
    name:"EnrollmentAskBasicDetails",
    props:{
        country_code: {
            type: String,
            default: null
        }
    },
    components:{
        AskNameAndPhone
    },
    data(){
        return{
            name:null,
            phone:null
        }
    },
    watch:{
        name(){
            this.$emit("update:name",this.name);
        },
        phone(){
            this.$emit("update:phone",this.phone);
        }
    },
    methods:{
        validate(){
            return this.$refs.namephoneform.validate();
        },
        onConfirm(){
            this.$emit("onConfirm");
        },
    }
}
</script>

<style>

</style>
